export default __webpack_public_path__ + "static/tecLogo-efa195aa7334633b500edfb17667a259.svg";